import axios from 'axios'


//axios.defaults.headers.common['Authorization'] = `Bearer ${(localStorage.getItem('token') || '')}`;

const instance = axios.create({
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  //console.log(config)
  if(localStorage.getItem('token')) {
    config.headers['Authorization'] = `Bearer ${(localStorage.getItem('token') || '')}`;
  }
  return config;
});

const postHeader = {
  headers: {
      'Content-Type': 'multipart/form-data'
  }
}

const parse = (data) => {
  let formData =  new FormData();
  for (const key in data) {
    if(data[key] != null && data[key] != 'undefined' && data[key] != '') {
      console.log(key, typeof data[key])
      formData.append(key, data[key])
    }
  }
  return formData;
}


export const userService = {
  async login(params) {
    await instance.get('/sanctum/csrf-cookie')
    return instance.post('/api/user/auth', params).then(res => res.data)
  },
  signup(params) {
    return instance.post('/api/user/signup', parse(params), postHeader).then(res => res.data)
  },
  update(params) {
    return instance.post('/api/user/update', parse(params), postHeader).then(res => res.data)
  },
  get({id}) {
    return instance.get(`/api/user/${id}`).then(res => res.data)
  },
  auth() {
    return instance.get(`/api/user`).then(res => res.data)
  },
  delete() {
    return instance.delete(`/api/user`).then(res => res.data)
  },
  block(params) {
    return instance.post('/api/user/block3', parse(params), postHeader).then(res => res.data)
  },
  like(params) {
    return instance.post('/api/user/like', parse(params), postHeader).then(res => res.data)
  },
  exclude(params) {
    return instance.post('/api/user/exclude3', parse(params), postHeader).then(res => res.data)
  },
  index(params) {
    return instance.get(`/api/card`, {params}).then(res => res.data)
  },
  friends(params) {
    return instance.get(`/api/user/friends`, {params}).then(res => res.data)
  }
}

export const eventService = {
  index(params) {
    return instance.get(`/api/event/`, {params}).then(res => res.data)
  },
  get({id}) {
    return instance.get(`/api/event/${id}`).then(res => res.data)
  },
  save(params) {
    return instance.post(`/api/event`, parse(params), postHeader).then( res => res.data )
  },
  join({id}) {
    return instance.post(`/api/event/join/${id}`).then( res => res.data )
  }
}


export const messageService = {
  index(params) {
    return instance.get(`/api/message/`, {params}).then(res => res.data)
  },
  get({id}) {
    return instance.get(`/api/message/${id}`).then(res => res.data)
  },
  save(params) {
    return instance.post(`/api/message`, parse(params), postHeader).then( res => res.data )
  }
}


export const blogService = {
  index(params) {
    return instance.get(`/api/blog/`, {params}).then(res => res.data)
  },
  get({id}) {
    return instance.get(`/api/blog/${id}`).then(res => res.data)
  },
  save(params) {
    return instance.post(`/api/blog`, parse(params), postHeader).then( res => res.data )
  }
}


export const reportService = {
  save(params) {
    return instance.post(`/api/report`, parse(params), postHeader).then( res => res.data )
  }
}

export const tagService = {
  index(params) {
    return instance.get(`/api/tag/`, {params}).then(res => res.data)
  },
  top(params) {
    return instance.get(`/api/tag/top`, {params}).then(res => res.data)
  },
  get(tag) {
    return instance.get(`/api/tag/${tag}`).then(res => res.data)
  }
}
